import { React, useEffect, useState } from "react";
import './ourTeam.scss';
import { showSnackbar } from "../../Components/Notification/Snackbar";
import ApiCaller from "../../services/api/APICaller";
import S3ImageViewerWithFallback from "../awsS3ImageViewer/ImgViewerWithFallback";



function OurTeam() {



  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  /**
  the legendary use effect function
  This will run very first on render
   */
  useEffect(() => {
    getDataArr();
  }, [])

  const getDataArr = () => {
    const apiCaller = new ApiCaller('team-members/our-team-members');
    apiCaller.getList().then(({ data }) => {
      setData(data.result)
    })
      .catch(() => showSnackbar().failure('Something went wrong'))
      .finally(() => setIsLoading(false));
  }



  // const ourTeamList = [
  //   {
  //     icon: AppIcons.sarah,
  //     title: 'Sarah Sajwani',
  //     position: 'CEO / FOUNDER',
  //     className: 'col-lg-3 col-md-6 col-sm-6 col-xs-12',
  //   },
  //   {
  //     icon: AppIcons.santiago,
  //     title: 'Santiago Carnicero',
  //     position: 'Board Director & Head of Tech Development',
  //     className: 'col-lg-3 col-md-6 col-sm-6 col-xs-12',
  //   },
  //   {
  //     icon: AppIcons.ambassador,
  //     title: 'Ambassador Vishnou Toolcanon',
  //     position: 'CHAIRMAN',
  //     className: 'col-lg-3 col-md-6 col-sm-6 col-xs-12',
  //   },
  //   {
  //     icon: AppIcons.Eliza,
  //     title: 'Eliza Evtimova',
  //     position: 'Operations Executive',
  //     className: 'col-lg-3 col-md-6 col-sm-6 col-xs-12',
  //   },
  //   {
  //     icon: AppIcons.Fadhil,
  //     title: 'Fadhil Sajwani',
  //     position: 'Real Estate Coach',
  //     className: 'col-lg-3 col-md-6 col-sm-6 col-xs-12',
  //   },
  //   {
  //     icon: AppIcons.Stefan,
  //     title: 'Stefan Evtimov',
  //     position: 'Head of Global Sales',
  //     className: 'col-lg-3 col-md-6 col-sm-6 col-xs-12',
  //   },
  //   {
  //     icon: AppIcons.Muhmd,
  //     title: 'Muhmd Waqas - Vicky',
  //     position: 'Finance Director',
  //     className: 'col-lg-3 col-md-6 col-sm-6 col-xs-12',
  //   },
  //   {
  //     icon: AppIcons.Novy,
  //     title: 'Novy Medina',
  //     position: 'Human Resource Officer',
  //     className: 'col-lg-3 col-md-6 col-sm-6 col-xs-12',
  //   },
  //   {
  //     icon: AppIcons.Enrilma,
  //     title: 'Enrilma Macrohon',
  //     position: 'Admin Officer',
  //     className: 'col-lg-3 col-md-6 col-sm-6 col-xs-12',
  //   },
  //   {
  //     icon: AppIcons.Jennifer,
  //     title: 'Jennifer Ohamara',
  //     position: 'Performance Marketing & Lead Generation Specialist',
  //     className: 'col-lg-3 col-md-6 col-sm-6 col-xs-12',
  //   },
  //   {
  //     icon: AppIcons.Mac,
  //     title: 'Mac Genuzon Beronilla',
  //     position: 'Creative Multimedia Specialist',
  //     className: 'col-lg-3 col-md-6 col-sm-6 col-xs-12',
  //   },
  //   {
  //     icon: AppIcons.Souha,
  //     title: 'Souha Ouertani',
  //     position: 'Property Consultant',
  //     className: 'col-lg-3 col-md-6 col-sm-6 col-xs-12',
  //   },
  //   {
  //     icon: AppIcons.Hmed,
  //     title: 'Hmed Ahmad Nur',
  //     position: 'Property Consultant',
  //     className: 'col-lg-3 col-md-6 col-sm-6 col-xs-12',
  //   },

  // ];

  return (
    <>
      {(isLoading) ? "Loading..." :
        <>
          {(!isLoading && data?.length === 0) ? "No Results found" :
            <>
              <div className="team-grid-wrp each-team-grid f-wrp">
                <div className={`center row`}>
                  {data.slice(0, 1).map((element, key) => (
                    <div className={`${element.className} col-lg-3 col-md-6 col-sm-6 col-xs-12 each-blk-sec`} key={key}>
                      <div className="each-team-blk f-wrp">
                        <div className='icon-blk'>
                          {element.imageURL && <span>
                            <S3ImageViewerWithFallback fileKey={element.imageURL} />
                          </span>}
                        </div>
                        <div className='cont-blk'>
                          <h3>{element.title}</h3>
                          {element.position && <p>{element.position}</p>}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="team-grid-wrp each-team-grid f-wrp">
                <div className="row">
                  {data.slice(1).map((element, key) => (
                    <div className={`${element.className} col-lg-3 col-md-6 col-sm-6 col-xs-12 each-blk-sec`} key={key}>
                      <div className="each-team-blk f-wrp">
                        <div className='icon-blk'>
                          {element.imageURL && <span>
                            <S3ImageViewerWithFallback fileKey={element.imageURL} />
                          </span>}
                        </div>
                        <div className='cont-blk'>
                          <h3>{element.title}</h3>
                          {element.position && <p>{element.position}</p>}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </>
          }
        </>
      }
    </>
  );
}

export default OurTeam;